const ENGLISH = {
  feedback: 'Feedback',
  board: 'Board',
  roadmap: 'Roadmap',
  changelog: 'Changelog',
  submitIdea: 'Submit an idea',
  title: 'Title',
  titlePlaceholder: 'A short, clear title',
  details: 'Details',
  detailsPlaceholder: 'Describe your idea (optional)',
  submit: 'Submit',
  cancel: 'Cancel',
  vote: 'Vote',
  comments: 'comments',
  addComment: 'Add a comment…',
  send: 'Send',
  noPosts: 'No posts yet - be the first!',
  nothingHere: 'Nothing here yet.',
  loading: 'Loading…',
  poweredBy: 'Powered by Chorala',
  back: 'Back',
  close: 'Close',
  describeBug: 'What went wrong?',
  screenshot: 'Screenshot',
  captureScreen: 'Capture screen',
  uploadImage: 'Upload image',
  shotHint: 'Capture, upload, or paste an image.',
  annotateHint: 'Drag to redact or highlight. We attach it to your report.',
  redact: 'Redact',
  highlight: 'Highlight',
  undo: 'Undo',
  remove: 'Remove',
  shotFailed: 'Could not read that image.',
}

type Dict = { [Key in keyof typeof ENGLISH]: string }

export const STRINGS = {
  en: ENGLISH,
  es: {
    feedback: 'Sugerencias',
    board: 'Ideas',
    roadmap: 'Hoja de ruta',
    changelog: 'Novedades',
    submitIdea: 'Enviar una idea',
    title: 'Título',
    titlePlaceholder: 'Un título breve y claro',
    details: 'Detalles',
    detailsPlaceholder: 'Describe tu idea (opcional)',
    submit: 'Enviar',
    cancel: 'Cancelar',
    vote: 'Votar',
    comments: 'comentarios',
    addComment: 'Añadir un comentario…',
    send: 'Enviar',
    noPosts: 'Aún no hay ideas - ¡sé el primero!',
    nothingHere: 'Todavía no hay nada.',
    loading: 'Cargando…',
    poweredBy: 'Con tecnología de Chorala',
    back: 'Atrás',
    close: 'Cerrar',
    describeBug: '¿Qué salió mal?',
    screenshot: 'Captura de pantalla',
    captureScreen: 'Capturar pantalla',
    uploadImage: 'Subir imagen',
    shotHint: 'Captura, sube o pega una imagen.',
    annotateHint: 'Arrastra para tapar o resaltar. La adjuntamos a tu reporte.',
    redact: 'Tapar',
    highlight: 'Resaltar',
    undo: 'Deshacer',
    remove: 'Quitar',
    shotFailed: 'No se pudo leer esa imagen.',
  },
  fr: {
    feedback: 'Suggestions',
    board: 'Idées',
    roadmap: 'Feuille de route',
    changelog: 'Nouveautés',
    submitIdea: 'Proposer une idée',
    title: 'Titre',
    titlePlaceholder: 'Un titre court et clair',
    details: 'Détails',
    detailsPlaceholder: 'Décrivez votre idée (facultatif)',
    submit: 'Envoyer',
    cancel: 'Annuler',
    vote: 'Voter',
    comments: 'commentaires',
    addComment: 'Ajouter un commentaire…',
    send: 'Envoyer',
    noPosts: 'Aucune idée pour le moment - soyez le premier !',
    nothingHere: 'Rien pour le moment.',
    loading: 'Chargement…',
    poweredBy: 'Propulsé par Chorala',
    back: 'Retour',
    close: 'Fermer',
    describeBug: 'Que s’est-il passé ?',
    screenshot: 'Capture d’écran',
    captureScreen: 'Capturer l’écran',
    uploadImage: 'Téléverser une image',
    shotHint: 'Capturez, téléversez ou collez une image.',
    annotateHint: 'Glissez pour masquer ou surligner. Nous la joignons à votre rapport.',
    redact: 'Masquer',
    highlight: 'Surligner',
    undo: 'Annuler',
    remove: 'Retirer',
    shotFailed: 'Impossible de lire cette image.',
  },
  sk: {
    feedback: 'Spätná väzba',
    board: 'Návrhy',
    roadmap: 'Plán vývoja',
    changelog: 'Novinky',
    submitIdea: 'Odoslať návrh',
    title: 'Názov',
    titlePlaceholder: 'Krátky a výstižný názov',
    details: 'Podrobnosti',
    detailsPlaceholder: 'Opíšte svoj návrh (nepovinné)',
    submit: 'Odoslať',
    cancel: 'Zrušiť',
    vote: 'Hlasovať',
    comments: 'komentáre',
    addComment: 'Pridať komentár…',
    send: 'Odoslať',
    noPosts: 'Zatiaľ žiadne príspevky - pridajte prvý!',
    nothingHere: 'Zatiaľ tu nič nie je.',
    loading: 'Načítava sa…',
    poweredBy: 'Používa Chorala',
    back: 'Späť',
    close: 'Zavrieť',
    describeBug: 'Čo sa pokazilo?',
    screenshot: 'Snímka obrazovky',
    captureScreen: 'Zachytiť obrazovku',
    uploadImage: 'Nahrať obrázok',
    shotHint: 'Zachyťte obrazovku, nahrajte alebo vložte obrázok.',
    annotateHint:
      'Ťahaním skryte citlivé údaje alebo zvýraznite časť obrázka. Priložíme ho k hláseniu.',
    redact: 'Skryť údaje',
    highlight: 'Zvýrazniť',
    undo: 'Späť',
    remove: 'Odstrániť',
    shotFailed: 'Obrázok sa nepodarilo načítať.',
  },
  de: {
    feedback: 'Feedback',
    board: 'Vorschläge',
    roadmap: 'Entwicklungsplan',
    changelog: 'Neuerungen',
    submitIdea: 'Vorschlag einreichen',
    title: 'Titel',
    titlePlaceholder: 'Ein kurzer, aussagekräftiger Titel',
    details: 'Details',
    detailsPlaceholder: 'Beschreiben Sie Ihren Vorschlag (optional)',
    submit: 'Einreichen',
    cancel: 'Abbrechen',
    vote: 'Abstimmen',
    comments: 'Kommentare',
    addComment: 'Kommentar hinzufügen…',
    send: 'Senden',
    noPosts: 'Noch keine Beiträge - machen Sie den Anfang!',
    nothingHere: 'Hier gibt es noch nichts.',
    loading: 'Wird geladen…',
    poweredBy: 'Bereitgestellt von Chorala',
    back: 'Zurück',
    close: 'Schließen',
    describeBug: 'Was ist schiefgelaufen?',
    screenshot: 'Screenshot',
    captureScreen: 'Bildschirm aufnehmen',
    uploadImage: 'Bild hochladen',
    shotHint: 'Nehmen Sie den Bildschirm auf, laden Sie ein Bild hoch oder fügen Sie es ein.',
    annotateHint:
      'Ziehen Sie, um Daten zu verdecken oder hervorzuheben. Das Bild wird dem Bericht beigefügt.',
    redact: 'Verdecken',
    highlight: 'Hervorheben',
    undo: 'Rückgängig',
    remove: 'Entfernen',
    shotFailed: 'Das Bild konnte nicht gelesen werden.',
  },
  cs: {
    feedback: 'Zpětná vazba',
    board: 'Návrhy',
    roadmap: 'Plán vývoje',
    changelog: 'Novinky',
    submitIdea: 'Odeslat návrh',
    title: 'Název',
    titlePlaceholder: 'Krátký a výstižný název',
    details: 'Podrobnosti',
    detailsPlaceholder: 'Popište svůj návrh (nepovinné)',
    submit: 'Odeslat',
    cancel: 'Zrušit',
    vote: 'Hlasovat',
    comments: 'komentáře',
    addComment: 'Přidat komentář…',
    send: 'Odeslat',
    noPosts: 'Zatím žádné příspěvky - přidejte první!',
    nothingHere: 'Zatím tu nic není.',
    loading: 'Načítání…',
    poweredBy: 'Používá Chorala',
    back: 'Zpět',
    close: 'Zavřít',
    describeBug: 'Co se pokazilo?',
    screenshot: 'Snímek obrazovky',
    captureScreen: 'Zachytit obrazovku',
    uploadImage: 'Nahrát obrázek',
    shotHint: 'Zachyťte obrazovku, nahrajte nebo vložte obrázek.',
    annotateHint:
      'Tažením skryjte citlivé údaje nebo zvýrazněte část obrázku. Přiložíme jej k hlášení.',
    redact: 'Skrýt údaje',
    highlight: 'Zvýraznit',
    undo: 'Zpět',
    remove: 'Odstranit',
    shotFailed: 'Obrázek se nepodařilo načíst.',
  },
} satisfies Record<string, Dict>

export type Translator = (key: string) => string

/** Resolve `auto` → navigator.language, then fall back base-language → English. */
export function resolveLocale(locale: string | undefined): string {
  let l = locale
  if (!l || l === 'auto') l = typeof navigator !== 'undefined' ? navigator.language : 'en'
  return l || 'en'
}

export function makeTranslator(locale: string): Translator {
  const dictionaries: Record<string, Record<string, string>> = STRINGS
  const lang = dictionaries[locale]
    ? locale
    : dictionaries[locale.slice(0, 2)]
      ? locale.slice(0, 2)
      : 'en'
  const dict = dictionaries[lang] ?? dictionaries.en ?? {}
  const en = dictionaries.en ?? {}
  return (key: string) => dict[key] ?? en[key] ?? key
}
